<div>
  <label *ngIf="label" [attr.for]="identifier">{{label}}</label>
  <p-inputMask #inputMask [(ngModel)]="value" [mask]="mask" (onBlur)="blurEvent($event)" (onComplete)="completeEvent($event)"
    [slotChar]="slotChar || '_'" [placeholder]="placeholder || ''" [disabled]="disabled" [readonly]="readonly" [inputId]="identifier"
    styleClass="form-control" [style]="style" [unmask]="unmask" [autoClear]="autoClear" [autoFocus]="autoFocus" (onFocus)="focusEvent($event)">
  </p-inputMask>
  <validation [elementBase]="this"></validation>
</div>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵx.html